<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['request_payout'] == 1">
      <div class="col-lg-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <BalanceDetails />
            <div v-if="request_error" style="background-color: #E34234; margin-right: 20%; margin-left: 20%;"
              class="text-center p-1 my-2 rounded text-white fw-bold">
              {{ request_error }}</div>
            <form class="" v-if="page == 1" @submit.prevent="requestForPayout">
              <h5>Requesting Person Details</h5>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="email" class="mb-0">Email:</label>
                    <input type="email" class="fw-bold form-control" id="email" v-model="email" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="contact" class="mb-0">Password:</label>
                    <input type="password" class="fw-bold form-control" id="contact" v-model="password" required>
                  </div>
                </div>
              </div>

              <br>

              <h5>Bank Details</h5>
              <div class="border border-2 rounded p-2">
                <div class="row mb-3">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="bank_name" class="mb-0">Bank Name:</label>
                      <input type="text" class="form-control text-primary fw-bold" id="bank_name" v-model="bank_name"
                        required>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="account_name" class="mb-0">Account Name:</label>
                      <input type="text" class="text-primary fw-bold form-control" id="account_name"
                        v-model="account_name" required>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="account_number" class="mb-0">Account Number:</label>
                      <input type="text" class="text-primary fw-bold form-control" id="account_number"
                        v-model="account_number" required>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="amount" class="mb-0">Amount:</label>
                      <input type="number" class="text-primary fw-bold form-control" id="amount" v-model="amount"
                        required>
                    </div>
                  </div>
                </div>
                <div class="mb-1">
                  <label for="description" class="mb-0">Description:</label>
                  <textarea id="description" class="form-control" v-model="description"></textarea>
                </div>
                <div class="form-check mb-3 d-flex align-items-end">
                  <input type="checkbox" class="form-check-input p-2 me-2" id="terms" v-model="terms_and_conditions"
                    required>
                  <label class="form-check-label" for="terms">
                    <small class="fw-bold">By clicking you agree to the <a class="" href="https://www.google.com"
                        target="_blank">Terms and Conditions</a> bounding this payout request.</small>
                  </label>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-primary" :disabled="!terms_and_conditions || request_loader">
                      <span v-if="request_loader" class="spinner-border spinner-border-sm"></span><span
                        v-if="request_loader"> Processing: {{ request_timer }}</span>
                      <span v-else>Apply</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Enter token to reset password -->
            <form @submit.prevent="verifyToken" v-if="page == 2">
              <div class="text-center h5">Enter OTP</div>
              <span class="d-block text-default text-center">Check your email for reset password token.</span>
              <span class="d-block text-default text-center"><i>Didn't receive email. <span style="cursor: pointer;"
                    class="text-primary" @click.prevent="repeatRequest"><b>Resend</b></span></i></span>
              <div class="row mt-3" style="margin-right: 25%; margin-left: 25%;">
                <input ref="token1" v-model="token1" @input="checkDigit('token1', 'token2')" @paste="handlePaste"
                  class="shadow shadow-sm mx-1 text-center col form-control form-control-lg" style="font-size: 30px;">
                <input ref="token2" v-model="token2" @input="checkDigit('token2', 'token3')"
                  class="shadow shadow-sm mx-1 text-center col form-control form-control-lg" style="font-size: 30px;">
                <input ref="token3" v-model="token3" @input="checkDigit('token3', 'token4')"
                  class="shadow shadow-sm mx-1 text-center col form-control form-control-lg" style="font-size: 30px;">
                <input ref="token4" v-model="token4" @input="checkDigit('token4', '')"
                  class="shadow shadow-sm mx-1 text-center col form-control form-control-lg" style="font-size: 30px;">
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-primary my-4">
                  Verify
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center>
              <span class="text-primary h6">You have no permission to View {{title}}</span>
            </center>          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import BalanceDetails from "./balanceDetails";

export default {
  page: {
    title: "Request Payout",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    BalanceDetails
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Request Payout",
      items: [{ text: "Dashboard", href: "/" }, { text: "Request Payout", active: true }],
      date_of_joining: new Date().toLocaleDateString('fr-CA'),
      dateofbirth: new Date().toLocaleDateString('fr-CA'),
      email: "",
      password: "",
      bank_name: "",
      account_name: "",
      account_number: "",
      amount: "",
      terms_and_conditions: false,
      page: 1, // 1 for request payout form, 2 for token verification form
      request_error: "",
      token1: "",
      token2: "",
      token3: "",
      token4: "",
      request_loader: false,
      request_timer: 10, //counting down for 10 - 13 seconds waiting for token
      description: "",
    };
  },

  methods: {
    checkDigit(current_model, next_model) {
      const regex = /^[0-9]*$/;
      let value = this[current_model];
      if (!regex.test(value)) {
        value = value.replace(/[^0-9]/g, '');
      }
      this[current_model] = value;

      if (this[current_model].length >= 1 && next_model) {
        this.$refs[next_model].focus();
      }
    },

    handlePaste(event) {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');

      if (pastedText.length > 0) this.token1 = pastedText.charAt(0) || '';
      if (pastedText.length > 1) this.token2 = pastedText.charAt(1) || '';
      if (pastedText.length > 2) this.token3 = pastedText.charAt(2) || '';
      if (pastedText.length > 3) this.token4 = pastedText.charAt(3) || '';

      if (this.token1 === '') this.$refs.token1.focus();
      else if (this.token2 === '') this.$refs.token2.focus();
      else if (this.token3 === '') this.$refs.token3.focus();
      else if (this.token4 === '') this.$refs.token4.focus();
    },

    async requestForPayout() {
      const obj = {
        email: this.email,
        password: this.password,
        bank_name: this.bank_name,
        account_name: this.account_name,
        account_number: this.account_number,
        amount: this.amount,
        description: this.description
      };
      try {
        this.request_loader = true;
        const countdown = setInterval(() => {
          if (this.request_timer > 0) {
            this.request_timer--;
          } else {
            clearInterval(countdown);
          }
        }, 1000);
        await axios.post("/request-payout", obj).then((response) => {
          if (response.status == 200) {
            this.$toast.success('Token sent to email');
            this.request_loader = false;
            this.request_error = "";
            this.page = 2
          } else {
            this.request_error = response.data.error
            this.request_loader = false;
          }
        });
      } catch (error) {
        this.request_loader = false;
        alert(error)
      }
    },

    repeatRequest() {
      axios.get('repeat-request-payout');
      setTimeout(() => {
        this.$toast.success('Token sent to email');
      }, 1500);
    },

    verifyToken() {
      const token = `${this.token1}${this.token2}${this.token3}${this.token4}`;
      axios.post('verify-request-token', { token }).then((response) => {
        if (response.status == 200) {
          this.request_error = "";
          this.$toast.success('Token verified. Payout request sent');
          this.page = 1;
          this.token1 = "";
          this.token2 = "";
          this.token3 = "";
          this.token4 = "";

          this.bank_name = "";
          this.account_name = "";
          this.account_number = "";
          this.amount = "";
          this.terms_and_conditions = false;

          this.email = "";
          this.password = "";
        } else {
          this.request_error = response.data.error;
        }
      });
    },
  },

  watch: {
    page(newValue) {
      if (newValue == 2) {
        this.$nextTick(() => {
          this.$refs.token1.focus();  // Focus on the input when div becomes visible
        });
      }
    },
  },
};
</script>